module.exports = __webpack_public_path__ + "img/authentification_github_api_doc.1884ab71.png";